import React from 'react'
import { joinKeys, useTranslationRankmi } from 'helpers/translations.helper'
import ConfirmationModal from 'components/ui/modals/confirmation/ConfirmationModal'
import restartParticipants from 'api/administration/monitoring/restartParticipants'
import { useParams } from 'react-router'
import { prefix } from '../constants'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

interface ConfirmationResetProps {
  show: boolean
  onSuccess: () => void
  onClose: () => void
}

export const ConfirmationReset: React.FC<ConfirmationResetProps> = ({
  show,
  onSuccess,
  onClose,
}) => {
  const t = useTranslationRankmi({
    prefix: joinKeys(prefix, 'modals.reset'),
  })
  const { courseId } = useParams<{
    courseId: string
  }>()

  const [loading, setLoading] = React.useState(false)

  return (
    <>
      <ConfirmationModal
        show={show}
        title={t('title')}
        text={t('text')}
        loading={loading}
        acceptButtonText={t('buttons.accept')}
        onAccept={async () => {
          if (courseId) {
            setLoading(true)
            try {
              await restartParticipants(courseId, {
                sendReport: true,
              })
              SuccessToast(t('toasts.success'))
              onSuccess()
            } catch (e) {
              console.error(e)
              ErrorToast(t('toasts.error'))
            }
            setLoading(false)
          }
        }}
        onClose={onClose}
      />
    </>
  )
}

export default ConfirmationReset
